import { Navigate,Outlet } from "react-router-dom";
import { updateUserOnlineStatusInFirebase } from "../utils/customFunctions";

const useAuth = () => {
  const user = localStorage.getItem("token");
  if (user) {
    updateUserOnlineStatusInFirebase(true);
    return true;
  } else {
    updateUserOnlineStatusInFirebase(false);
    return false;
  }
};
const PublicRoutes = () => {
  const auth = useAuth();
  return auth ? <Navigate to="/dashboard" /> : <Outlet />;
};

export default PublicRoutes;
